import { render, staticRenderFns } from "./nav-bg-upload.vue?vue&type=template&id=19fa1881&scoped=true&"
import script from "./nav-bg-upload.vue?vue&type=script&lang=js&"
export * from "./nav-bg-upload.vue?vue&type=script&lang=js&"
import style0 from "./nav-bg-upload.vue?vue&type=style&index=0&id=19fa1881&scoped=true&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fa1881",
  null
  
)

export default component.exports